import { BaseClient } from '../client';

export interface VeiculoPropostaSuperada {
	marca?: string;
	modelo?: string;
	placa?: string;
	url_foto?: string;
}

export interface NotificacaoPropostaSuperada {
	id?: number;
	num_id_anuncio: number;
	data_superacao: string;
	val_superado: number;
	veiculos: VeiculoPropostaSuperada[];
}

export interface ResponsePropostasSuperadas {
	success: boolean;
	message: string;
	data: NotificacaoPropostaSuperada[];
}

export const getPropostasSuperadas = async (): Promise<NotificacaoPropostaSuperada[]> => {
	try {
		const response = await BaseClient.get<ResponsePropostasSuperadas>('/Anuncios/Get/Propostas-Superadas');
		if (response.data && Array.isArray(response.data.data)) {
			return response.data.data;
		}
		return [];
	} catch (error) {
		console.error('Erro ao buscar propostas superadas:', error);
		return [];
	}
};

export const marcarPropostaSuperadaVisualizada = async (id: number): Promise<void> => {
	try {
		await BaseClient.put(`/Anuncios/Put/Proposta-Superada/${id}`);
	} catch (error) {
		console.error('Erro ao marcar proposta superada como visualizada:', error);
	}
};

